import Vue from 'vue';

import Router from 'vue-router';

import constants from './constants';
import store from './store';

Vue.use(Router);

function isProfileDisabled(to, from, next) {
  console.log(store.getters['Auth/isDisabled']);
  if (store.getters['Auth/isDisabled']) {
    next('/disabled');
  } else {
    next();
  }
}

const router = new Router({
  mode: 'history',
  base: constants.baseUrl,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      path: '/thank-you',
      name: 'thank-you',
      component: () => import('./views/home/ThankYou.vue'),
      meta: {
        requireAnonymous: true,
      },
    },
    // URL: /auth
    {
      path: '/auth',
      alias: '/',
      component: () => import('./views/auth/Auth.vue'),
      children: [
        {
          path: '',
          redirect: { name: 'login' },
        },
        // URL: /auth/login
        {
          path: 'login',
          name: 'login',
          component: () => import('./views/auth/pages/Login.vue'),
          meta: {
            requireAnonymous: true,
          },
        },
        // URL: /auth/signup
        {
          path: 'signup',
          name: 'signup',
          component: () => import('./views/auth/pages/SignUp.vue'),
          meta: {
            requireAnonymous: true,
          },
        },
        // URL: /auth/invite/merchant?email,token
        {
          path: 'invite/merchant',
          name: 'invite-merchant',
          component: () => import('./views/auth/pages/Invite/index.vue'),
          meta: {
            requireAnonymous: true,
          },
        },
        // URL: /auth/create-account
        {
          path: 'create-account',
          name: 'create-account',
          component: () => import('./views/auth/pages/CreateAccount'),
          meta: {
            requireAnonymous: true,
          },
        },
        // URL: /auth/reset-password
        {
          path: 'reset-password',
          name: 'reset-password',
          component: () => import('./views/auth/pages/ResetPassword.vue'),
          meta: {
            requireAnonymous: true,
          },
        },
      ],
    },
    {
      path: '/facebook',
      name: 'facebook',
      component: () => import('./views/social/Facebook.vue'),
    },
    {
      path: '/instagram',
      name: 'instagram',
      component: () => import('./views/social/Instagram.vue'),
    },
    {
      path: '/twitter',
      name: 'twitter',
      component: () => import('./views/social/Twitter.vue'),
    },
    // URL: /profile
    {
      path: '/profile',
      component: () => import('./views/profile/Profile.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/profile/settings/Settings.vue'),
          children: [
            {
              path: '',
              name: 'profile',
              redirect: { name: 'profile-details' },
            },
            {
              path: 'details',
              name: 'profile-details',
              component: () => import('./views/profile/settings/components/ProfileDetails.vue'),
            },
            {
              path: 'contracts',
              name: 'profile-contracts',
              component: () => import('./views/profile/settings/components/Contracts.vue'),
            },
            {
              path: 'notifications',
              name: 'profile-notifications',
              component: () => import('./views/profile/settings/components/Notifications.vue'),
            },
            {
              path: 'payments',
              name: 'profile-payments',
              component: () => import('./views/profile/settings/components/PaymentDetails.vue'),
            },
            {
              path: 'premium',
              name: 'profile-premium',
              component: () => import('./views/profile/settings/components/PremiumDetails.vue'),
            },
          ],
        },
        {
          path: 'payments',
          name: 'profile-payments-history',
          beforeEnter: isProfileDisabled,
          component: () => import('./views/profile/payments/Payments.vue'),
          children: [
            {
              path: 'history',
              name: 'history',
              component: () => import('./views/profile/payments/PaymentHistory.vue'),
            },
          ],
        },
    /*     {
          path: 'contracts-create',
          name: 'contracts-create',
          component: () => import('./views/profile/contracts/ContractCreate.vue'),
        },
        {
          path: 'contracts-edit/:id',
          name: 'contracts-edit',
          component: () => import('./views/profile/contracts/ContractCreate.vue'),
        },
        {
          path: 'contracts-detail/:id/campaign/:campaignId',
          name: 'contracts-detail',
          component: () => import('./views/profile/contracts/ContractDetail.vue'),
        }, */
      ],
      meta: {
        // requireAuthenticated: true,
      },
    },
    // URL: /companies
    {
      path: '/companies',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/companies/Companies.vue'),
      children: [
        {
          path: '',
          name: 'companies',
          component: () => import('./views/companies/dashboard/Dashboard.vue'),
        },
        {
          path: ':id',
          component: () => import('./views/companies/company/Company.vue'),
          redirect: ':id/campaigns',
          children: [
            {
              name: 'company-campaigns',
              path: 'campaigns',
              component: () => import('./views/companies/company/campaigns/Campaigns.vue'),
            },
            {
              name: 'company-groups',
              path: 'groups',
              component: () => import('./views/companies/company/groups/InfluencerGroups.vue'),
            },
            {
              name: 'company-contracts',
              path: 'contracts',
              component: () => import('./views/companies/company/contracts/Contracts.vue'),
            },
          ],
        },

        {
          path: ':id/create',
          name: 'company-create-campaign',
          component: () => import('./views/companies/company/create/CreateCampaign.vue'),
        },
        {
          path: ':id/details/:campaignId',
          name: 'campaign-details',
          component: () => import('./views/companies/company/details/CampaignDetails.vue'),
        },
        {
          path: ':id/contracts-create',
          name: 'contracts-create',
          component: () => import('./views/companies/company/contracts/ContractCreate.vue'),
        },
        {
          path: ':id/contracts-edit/:contractId',
          name: 'contracts-edit',
          component: () => import('./views/companies/company/contracts/ContractCreate.vue'),
        },
        {
          path: ':id/contracts-detail/:contractId/campaign/:campaignId',
          name: 'contracts-detail',
          component: () => import('./views/companies/company/contracts/ContractDetail.vue'),
        },
        {
          name: 'company-create-group',
          path: ':id/create-group',
          component: () => import('./views/companies/company/groups/GroupDetails.vue'),
        },
      ],
    },
    /* {
      path: '/campaigns',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/campaigns/Campaigns.vue'),
      children: [
        {
          path: '',
          name: 'campaigns',
          component: () => import('./views/campaigns/dashboard/Dashboard.vue'),
        },
        {
          path: 'create/:id?',
          name: 'create-campaign',
          component: () => import('./views/campaigns/create/createCampaign.vue'),
        },
        {
          path: 'details/:id',
          name: 'campaign-details',
          component: () => import('./views/campaigns/details/campaignDetails.vue'),
        },
      ],
    },
    */
    /* {
      path: '/groups',
      name: 'groups',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/groups/Groups.vue'),
      children: [
        {
          path: ':id?',
          name: 'group',
          component: () => import('./views/groups/GroupDetails.vue'),
        },
      ],
    },
    */
    {
      path: '/payments',
      name: 'payments',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/payments/Payments.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/contact/Contact.vue'),
    },
    {
      path: '/disabled',
      name: 'disabled',
      component: () => import('./views/disabled/Disabled.vue'),
    },
    // URL: /terms-and-conditions
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: () => import('./views/footerPages/TermsConditions.vue'),
      meta: {
        requireAnonymous: false,
      },
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: () => import('./views/footerPages/Privacy.vue'),
      meta: {
        requireAnonymous: false,
      },
    },
    {
      path: '/privacy',
      redirect: '/privacypolicy',
    },
    // URL: /faq
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/footerPages/FAQ.vue'),
      meta: {
        requireAnonymous: true,
      },
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      beforeEnter: isProfileDisabled,
      component: () => import('./views/subscriptions/Subscriptions.vue'),
    },
  ],
});

// Route authentication middleware
router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuthenticated === true)) {
    // the user has to be logged in
    if (store.getters['Auth/isAuthenticated']) {
      next();
    } else {
      next('/auth');
    }
  } else if (to.matched.some(r => r.meta.requireAnonymous === true)) {
    // the user must not be logged in
    if (store.getters['Auth/isAnonymous']) {
      next();
    } else {
      next('/companies');
    }
  } else {
    // it doesn't matter whether the user's logged in or not
    next();
  }
});

export default router;
